export interface CommonSocketDeps {
  setIsAudioClientMute: (mute: boolean) => void;
  setIsVideoClientMute: (mute: boolean) => void;
  onStopScreenShare?: () => void;
  onGroupConnectionRequest?: (data: { identity: string; displayName?: string }) => void;
  onConnectionAllowed?: (data: { for: string }) => void;
  onRaisedHandChange?: (data: { identity: string; raised: boolean }) => void;
}

export function handleCommonSocketMessage(msg: { action: string; data: unknown }, deps: CommonSocketDeps): boolean {
  const data = typeof msg.data === 'object' && msg.data !== null ? (msg.data as Record<string, unknown>) : undefined;

  if (msg.action === 'group_connection_request' && data) {
    deps.onGroupConnectionRequest?.({
      identity: String(data.identity ?? ''),
      displayName: typeof data.displayName === 'string' ? data.displayName : undefined,
    });
    return true;
  }

  if (msg.action === 'connection_allowed' && data?.for) {
    deps.onConnectionAllowed?.({ for: String(data.for) });
    return true;
  }

  if (msg.action === 'group_hand_status' && data?.identity) {
    deps.onRaisedHandChange?.({
      identity: String(data.identity),
      raised: Boolean(data.raised),
    });
    return true;
  }

  if (msg.action === 'micro_client') {
    deps.setIsAudioClientMute(Boolean(msg.data));
    return true;
  }

  if (msg.action === 'video_client') {
    deps.setIsVideoClientMute(Boolean(msg.data));
    return true;
  }

  if (msg.action === 'stop_screen_share') {
    deps.onStopScreenShare?.();
    return true;
  }

  return false;
}
